import { useSelector } from "react-redux";
import useComponentIdGenerator from "hooks/useComponentIdGenerator";
import { NODE_TYPES } from "constants/flowDesigner";

const useCreateSubFlowNode = () => {
   const { isVerticalCanvasDirection } = useSelector((state) => state?.designer?.settings);
   const { generateNodeId } = useComponentIdGenerator();

   const createSubFlowNode = (invokeNode, subFlowData, positionOffset = 250) => {
      const newSubFlowNodeId = generateNodeId();
      const newNode = {
         id: newSubFlowNodeId,
         type: NODE_TYPES.SUBFLOW,
         position: {
            x: invokeNode.position.x + positionOffset,
            y: invokeNode.position.y
         },
         data: {
            label: subFlowData?.name ?? "",
            id: newSubFlowNodeId,
            type: NODE_TYPES.SUBFLOW,
            flowId: subFlowData?.id ?? null,
            parentNodeId: invokeNode.id
         },
         targetPosition: isVerticalCanvasDirection ? "right" : "top",
         selected: false,
         width: 197,
         height: 54,
         style: { opacity: 1, zIndex: -1 }
      };
      return newNode;
   };
   return {
      createSubFlowNode
   };
};

export default useCreateSubFlowNode;
